module.exports = __webpack_public_path__ + "img/pet-care.97a7d9d7.png";